import { emailRegex, numericRegex } from '../constants/Regex';

export const validateEmail = (email: string) => {
  return emailRegex.test(email);
};

export const validatePassword = (password: string) => {
  return password.length >= 6;
};

export const validatePhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber.startsWith('0') || phoneNumber.length !== 11) {
    return false;
  }

  return numericRegex.test(phoneNumber);
};

export const validateCardNumber = (cardNumber: string) => {
  if (cardNumber.length !== 16 && cardNumber.length !== 15) {
    return false;
  }

  return numericRegex.test(cardNumber);
};

export const validateCvc = (cvc: string) => {
  if (cvc.length !== 3) {
    return false;
  }

  return numericRegex.test(cvc);
};
